import api from "api";

export function getCustomerDataFromCaseId(case_id) {
  return api.get(`customer-details?caseId=${case_id}`);
}

export function saGetCustomerIssues(case_id) {
  return api.get(`v1/smart-assist/all-issues/${case_id}`);
}

export function saSubmitIssue({ caseId, issue, engagementId }) {
  return api.get(`v1/smart-assist/probing-questions/${caseId}?issue=${issue}&engagementTxnId=${engagementId}&source=crm`);
}

export function saSubmitBulkResponse(formId, body) {
  return api.post(`v1/smart-assist/submit-response-bulk/${formId}`, body);
}

export function saEvaluateResolution(caseId) {
  return api.get(`v1/smart-assist/evaluate-resolution/${caseId}`);
}

export function saPastResolution(caseId, issue) {
  return api.get(`v1/smart-assist/past-resolutions/${caseId}?issue=${issue}`);
}

export function saPastResponse(caseId, body) {
  return api.post(`v1/smart-assist/past-response/${caseId}`, body);
}
